import React from 'react';
import ReactSelect from 'react-select';
import ReactAsyncSelect from 'react-select/lib/Async';

export const Select = ({ ...props }) => <ReactSelect {...props} />;
export const AsyncSelect = ({ ...props }) => <ReactAsyncSelect {...props} />;

export default Select;



// WEBPACK FOOTER //
// ./app/javascript/common/components/Select/Select.js